
import { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { ReportDetail } from '@/types/salary';
import { RejectionReasonModal } from '../../teacher/RejectionReasonModal';

interface SalaryReportTableProps {
  reports: ReportDetail[];
}

export function SalaryReportTable({ reports }: SalaryReportTableProps) {
  const [showRejectionModal, setShowRejectionModal] = useState(false);
  const [selectedRejectionReason, setSelectedRejectionReason] = useState('');

  // Sort reports by teaching_date from earliest to latest
  const sortedReports = [...reports].sort((a, b) => {
    return new Date(a.teaching_date).getTime() - new Date(b.teaching_date).getTime();
  });

  const renderStatusCell = (report: ReportDetail) => {
    switch (report.status) {
      case 'APPROVED':
        return <span className="text-green-600">✓</span>;
      case 'REJECTED':
        return (
          <Button
            variant="destructive"
            size="sm"
            onClick={() => {
              setSelectedRejectionReason(report.rejection_reason || 'ไม่มีเหตุผลที่ระบุ');
              setShowRejectionModal(true);
            }}
          >
            ไม่อนุมัติ
          </Button>
        );
      case 'WAITING':
      default:
        return '-';
    }
  };

  return (
    <>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>วันที่</TableHead>
            <TableHead>ชื่อ</TableHead>
            <TableHead>ประเภทการสอน</TableHead>
            <TableHead>tier</TableHead>
            <TableHead>สถานที่</TableHead>
            <TableHead className="text-right">ระดับชั้น</TableHead>
            <TableHead className="text-right">ชั่วโมง</TableHead>
            <TableHead className="text-right">ชีท</TableHead>
            <TableHead className="text-center">ถูกหัก 50%</TableHead>
            <TableHead className="text-center">ถูกหัก 100%</TableHead>
            <TableHead className="text-center">ลากะทันหัน</TableHead>
            <TableHead className="text-center">สถานะ</TableHead>
            <TableHead className="text-right">รายได้ (บาท)</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {sortedReports.map((report) => (
            <TableRow key={report.report_id}>
              <TableCell>{report.teaching_date}</TableCell>
              <TableCell>
                น้อง {report.student_nickname} {report.student_full_name} ({report.student_id})
              </TableCell>
              <TableCell>
                <div>
                  {report.class_type} {report.is_inter ? " Inter" : ""}
                  {report.is_special_class && <div className="text-xs text-muted-foreground">คลาสพิเศษ</div>}
                </div>
              </TableCell>
              <TableCell>{report.tier}</TableCell>
              <TableCell>{report.location}</TableCell>
              <TableCell className="text-right">
                {report.grade === "primary" ? "ประถม" : report.grade === "high_school" ? "มัธยม" : "พิเศษ"}
              </TableCell>
              <TableCell className="text-right">{report.duration}</TableCell>
              <TableCell className={`text-right ${report.sheet_approve_status !== 'APPROVED' ? 'text-red-500' : ''}`}>
                {report.sheet_approve_status === 'APPROVED' ? 'มี' : ''}
              </TableCell>
              <TableCell className="text-center">
                {report.is_late_submit ? 'ใช่' : ''}
              </TableCell>
              <TableCell className="text-center">
                {report.is_late_beyond_2_days ? '✓' : ''}
              </TableCell>
              <TableCell className="text-center">
                {report.learning_status === "น้องไม่เข้าเรียน (ลากะทันหัน)" && report.sudden_leave_hours_deducted ? "✓" : 
                 report.learning_status === "น้องไม่เข้าเรียน (ลากะทันหัน)" && !report.sudden_leave_hours_deducted ? (
                  <span className="text-red-500">✗</span>
                 ) : "-"}
              </TableCell>
              <TableCell className="text-center">
                {renderStatusCell(report)}
              </TableCell>
              <TableCell className="text-right">
                {report.salary.toLocaleString()}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <RejectionReasonModal
        isOpen={showRejectionModal}
        onClose={() => setShowRejectionModal(false)}
        rejectionReason={selectedRejectionReason}
      />
    </>
  );
}
